import { createContext, useContext } from "react";

export type RequestFormReviewValidationContextType = {
  hasAttemptedReview: boolean;
  erroredSections: string[];
  clearFieldError?: (path: string) => void;
  syncErroredSections?: () => void;
};

export const RequestFormReviewValidationContext = createContext<RequestFormReviewValidationContextType>({
  hasAttemptedReview: false,
  erroredSections: [],
});

export function useRequestFormReviewValidation() {
  return useContext(RequestFormReviewValidationContext);
}
